/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2022-11-14 14:47:07
 * @LastEditors: changfeng
 * @LastEditTime: 2023-06-01 16:52:07
 */
import React, { useCallback } from 'react';
import { LogoutOutlined } from '@ant-design/icons';
import { Avatar, Menu, Spin, Dropdown, Space } from 'antd';
import { history, useModel } from 'umi';
import { stringify } from 'querystring';
import styles from './index.less';

import { removeAccessToken } from '@/utils/cookie';
/**
 * 退出登录，并且将当前的 url 保存
 */
const loginOut = async () => {
  // 删除cookie和token
  localStorage.setItem('Authorization', '');
  removeAccessToken();
  const { query = {}, search, pathname } = history.location;
  const { redirect } = query; // Note: There may be security issues, please note

  if (window.location.pathname !== '/login' && !redirect) {
    history.replace({
      pathname: '/login',
      search: stringify({
        redirect: pathname + search,
      }),
    });
  }
};

const AvatarDropdown = () => {

  const { initialState } = useModel('@@initialState');

  const loading = (
    <span className={`${styles.action} ${styles.account}`}>
      <Spin
        size="small"
        style={{
          marginLeft: 8,
          marginRight: 8,
        }}
      />
    </span>
  );

  if (!initialState) {
    return loading;
  }

  const { currentUser } = initialState;

  // if (!currentUser || !currentUser.username) {
  //   return loading;
  // }

  const items: MenuProps['items'] = [
    {
      key: '1',
      label: (
        <Menu>
          <Menu.Item key="logout" onClick={() => loginOut()}>
            <LogoutOutlined />
              退出登录
          </Menu.Item>
        </Menu>
      ),
    },
  ];
  return (
    <div className='headerContainer'>
      <div style={{ display: 'flex',verticalAlign:'middle' }}>
        <div style={{borderRadius:20,overflow:'hidden'}}>
          <img style={{width:40,height:40}} src='https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif?imageView2/1/w/80/h/80'  />
        </div>
      <h2 style={{margin:'auto'}}>NewRate OA</h2>
      </div>
      <Dropdown menu={{ items }}>
      <span className={`${styles.action} ${styles.account}`}>
          <a onClick={(e) => e.preventDefault()}>
          <Space>
            <Avatar
              size="small"
              className={styles.avatar}
              src="https://gw.alipayobjects.com/zos/antfincdn/XAosXuNZyF/BiazfanxmamNRoxxVxka.png"
              alt="avatar"
            />
              <span className={`${styles.name} anticon`}>{currentUser?.name}</span>
          </Space>
          </a>
      </span>
  </Dropdown>
    </div>
 
  );
};

export default AvatarDropdown;
